import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a simple upholstered ottoman (~0.6 x 0.6 x 0.4) on wooden
// feet, matching the sofa family's fabric.
const FABRIC = "#8a9aa8";
const FABRIC_DARK = "#758898";
const WALNUT = "#7a5a3a";

export const ottoman = defineModel({
  id: "ottoman",
  batchId: "modern",
  name: "Ottoman",
  tags: ["modern", "interior", "furniture", "seating", "living-room"],
  summary: "A simple upholstered ottoman on wooden feet.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    return [
      // upholstered body
      { geometry: new THREE.BoxGeometry(0.6, 0.28, 0.6), color: FABRIC, position: [0, 0.22, 0] },
      // top cushion
      { geometry: new THREE.BoxGeometry(0.56, 0.08, 0.56), color: FABRIC_DARK, position: [0, 0.38, 0] },
      // wooden feet
      { geometry: new THREE.BoxGeometry(0.06, 0.08, 0.06), color: WALNUT, position: [-0.24, 0.04, 0.24] },
      { geometry: new THREE.BoxGeometry(0.06, 0.08, 0.06), color: WALNUT, position: [0.24, 0.04, 0.24] },
      { geometry: new THREE.BoxGeometry(0.06, 0.08, 0.06), color: WALNUT, position: [-0.24, 0.04, -0.24] },
      { geometry: new THREE.BoxGeometry(0.06, 0.08, 0.06), color: WALNUT, position: [0.24, 0.04, -0.24] },
    ];
  },
  animations: [],
});
